import React from 'react';
import {Section} from '../section/Section';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import css from './MonitorSection.module.scss';

const MONITOR_LIST_URL =
  'https://www.blog.pulsoid.net/monitors?from=vrchat-setup';

export const MonitorSection = () => {
  return (
    <Section
      title="Get a compatible Heart Rate Monitor (HRM)"
      number={1}
      type="monitor-selection"
    >
      <div className={css.container}>
        <div>
          <div className={css.title}>Read complete Pulsoid HRM guide</div>
          <div className={css.subtitle}>
            Pulsoid requires a{' '}
            <a className={css.link} href="MONITOR_LIST_URL">
              Compatible monitor
            </a>{' '}
            to stream your heart rate.
          </div>
          <div className={css.subtitle}>
            We crafted the list of devices that work the best.
          </div>
        </div>
        <div className={css.button}>
          <ButtonV2 href={MONITOR_LIST_URL}>Read HRM guide</ButtonV2>
        </div>
      </div>
    </Section>
  );
};
